import { render } from "./ClassgroupDetails.vue?vue&type=template&id=42f20396&ts=true"
import script from "./ClassgroupDetails.vue?vue&type=script&lang=ts"
export * from "./ClassgroupDetails.vue?vue&type=script&lang=ts"

import "./ClassgroupDetails.vue?vue&type=style&index=0&id=42f20396&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/com.latudio.www.teachers_staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__